import React from 'react';
import videojs from 'video.js'
import 'videojs-contrib-ads';
import 'videojs-ima';
import {inject} from "../mixins/dom";

class VideoPlayer extends React.Component {
  constructor(props) {
    super(props);

    this._videoId = 'video-player-' + Math.ceil(Math.random() * 1000);

    this.state = {
      autoplay: typeof(props.autoplay) !== "undefined" ? props.autoplay : true,
      controlState: props.controlState || "default"
    }
  }

  componentDidMount() {
    const { video } = this.props;

    if (!video || !video.video_info) {
      return;
    }

    if (video.video_info.video_type === "hosted" && (!video.file || !video.file.url)) {
      return
    }

    if (video.video_info.video_type === "remote" && !video.embed) {
      return
    }

    if (this.props.advert) {
      inject('//imasdk.googleapis.com/js/sdkloader/ima3.js', 'js', {
        callback: () => {
          this.initializeVideo();
        }
      });
    } else {
      this.initializeVideo();
    }

    /*if (this.props.advert === "banner") {
      this.player.ima({
        id: this._videoId,
        adTagUrl: 'https://syndication.exoclick.com/splash.php?idzone=3390867',
        numRedirects: 1
      });
    }*/
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props.muted !== prevProps.muted) {
      this.videoNode.muted = this.props.muted;
    }
  }

  componentWillUnmount() {
    if (this.player && typeof(this.player.dispose) === "function") {
      this.player.dispose()
    }
  }

  initializeVideo() {
    const { video } = this.props;

    const videoProps = Object.keys(this.props)
      .filter(key => !["video"].includes(key))
      .reduce((obj, key) => {
        obj[key] = this.props[key];
        return obj;
      }, {});

    let videoArgs = {
      sources: [{src: video.video_info.video_type === "remote" ? video.embed : video.file.url, type: "video/mp4"}],
      autoplay: false,
      controls: false,
      ...videoProps
    };

    if (video.images && video.images.length) {
      videoArgs.poster = video.images[0].urls.url;
    }

    this.player = videojs(this.videoNode, videoArgs);
    this.player.on('volumechange', () => {
      localStorage.setItem('videojs-volume', this.player.volume());
    });

    const volume = localStorage.getItem('videojs-volume');
    if (volume) {
      this.player.volume(volume);
    }

    if (this.props.muted || this.props.mute) {
      this.player.muted(true);
    }

    this.addAdverts();
  }

  addAdverts() {
    if (!this.props.advert) {
      return;
    }

    if (typeof this.player.ima !== "function") {
      return;
    }

    let adverts = this.props.advert;
    if (!Array.isArray(adverts)) {
      adverts = [adverts];
    }

    let imaOpts = {};
    adverts.forEach(advert => {
      switch (advert) {
        case "preroll":
          imaOpts.preroll = {
            id: this._videoId,
            // adTagUrl: 'https://syndication.realsrv.com/splash.php?idzone=3390817',
            adTagUrl: "https://s.magsrv.com/splash.php?idzone=5182304", // exclusive Ad Tag
            numRedirects: 1
          };
          break;
        case "pauseBanner":
          imaOpts.pause = {
            id: this._videoId,
            adTagUrl: 'https://s.magsrv.com/splash.php?idzone=4061192',
            numRedirects: 1,
            forceNonLinearFullSlot: true
          };
          break;
        default:
          break;
      }
    });

    if (imaOpts.preroll) {
      this.player.ima(imaOpts.preroll);
    }

    /*if (imaOpts.pause && imaOpts.preroll) {
      this.player.one("pause", () => {
        const time = this.player.currentTime();

        this.player.one("ads-ad-started", () => {
          this.player.pause();
          this.player.currentTime(time);

          setTimeout(() => {
            this.player.one("pause", () => {
              this.player.ima.changeAdTag(null);
            });
          }, 100);
        });

        this.player.ima.setContentWithAdTag(null, imaOpts.pause.adTagUrl, false);
        this.player.ima.requestAds();
      })
    }*/
  }

  play() {
    if (!this.playing()) {
      this.player.play();
    }
  }

  pause() {
    if (this.playing()) {
      this.player.pause();
    }
  }

  playing() {
    return !!(this.videoNode.currentTime > 0 && !this.videoNode.paused && !this.videoNode.ended && this.videoNode.readyState > 2);
  }

  render() {
    let classes = ["video-js"];
    if (this.props.className) {
      classes.push(this.props.className);
    } else {
      classes.push("vjs-16-9")
    }

    return (
      <div className={'video-container ' + (this.props.controls === false ? "no-controls" : '')}>
        <video ref={ node => this.videoNode = node } autoPlay={this.state.autoplay} className={classes.join(" ")} id={this._videoId} poster={this.props.poster} />
      </div>
    )
  }
}

export default VideoPlayer;
